import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ResumeBox from '@/common/components/ResumeBox'
import { ShowHeader } from '@/common/components/ShowHeader'
import { useTmaisFaq } from '@/features/tmaisFaqs/hooks/useTmaisFaq'
import { useNavigate, useParams } from 'react-router-dom'

const ShowTmaisFaq = () => {
  const { id = '' } = useParams()

  const navigate = useNavigate()

  const { data: faq, isLoading: faqIsLoading, error: faqError = {} as any, refetch: refetchFaq } = useTmaisFaq(id)

  return (
    <div className="inner-screen">
      <ShowHeader
        goBack
        goBackProps={{ fallback: `/tmais-faqs` }}
        title="FAQs"
        subtitle={faq?.question}
        isLoading={faqIsLoading}
        buttons={
          <Button
            onClick={() => navigate('edit')}
            operationKlassToCheckPermission="Admin::Tmais::Faqs::Update"
            disabled={faqIsLoading || faqError?.status === 403}
          >
            Editar
          </Button>
        }
      />

      {faqIsLoading ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper className="flex-1" statusCode={faqError?.status} refetchFunction={refetchFaq}>
          <Box className="flex flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)] overflow-auto">
            <p className="text-lg font-bold">Detalhes do FAQ</p>

            <ResumeBox label="Pergunta" value={faq?.question ?? '--'} />

            <ResumeBox label="Resposta" value={faq?.answer ?? '--'} valueClassName="whitespace-pre-line" />

            <ResumeBox label="Posição" value={faq?.position?.toString() ?? '--'} />
          </Box>
        </ErrorMessageWrapper>
      )}
    </div>
  )
}

export default ShowTmaisFaq
